import React, {useEffect, useRef, useState} from "react";
import {Row} from "antd";
import {useFetch} from "../../../hooks/useFetch";
import stores from "../../../store/stores";
import Filters from "./filters/Filters";
import {FiltersWrapper} from "../../_defaultComponents/FilterComponents/FiltersWrapper";

import ResponsiveDataTable from "./responsiveDataTable/ResponsiveDataTable";
import useIsFocused from "../../../hooks/useIsFocused";
import {isNumeric} from "utils/helpers";

const RELOAD_INTERVAL = 1000 * 3; //3 seconds

const PoolIntensities = () => {
    const isAgency = stores.meStore.checkRole("isAgency");
    const [recall, setRecall] = useState(true);
    const isFocused = useIsFocused();
    const [currentPage, setCurrentPage] = useState(1);
    const [filters, setFilters] = useState({
        city: "all",
        availableRate: "all",
        slotRate: "all",
        activity: "active",
        // Acente için Entegrasyon Tipi başlangıçta seçili gelmemeli, filtre seçilene kadar veri çekilmemeli.
        integrationType: isAgency ? undefined : "all",
        poolIds: [],
        companyId: undefined,
        subCompanyId: undefined
    });
    const recallRef = useRef(recall);
    recallRef.current = recall;

    const filtersKey = JSON.stringify(filters);

    // Acente, "Dedike Entegrasyon" için firma seçtiğinde eşleşen havuz bulunamazsa
    // backend'in boş poolIds'i "filtresiz" yorumlamasını önlemek için fetch atlanır.
    const noMatchingDedicatedCompanyPools =
        isAgency &&
        filters.integrationType === "dedicatedIntegration" &&
        Boolean(filters.companyId) &&
        !filters.poolIds?.length;

    const shouldFetch =
        !noMatchingDedicatedCompanyPools && (isAgency ? Boolean(filters.integrationType) : true);

    const [loading, poolsAvailableRates] = useFetch({
        fetchFn: stores.poolShiftStore.getPoolsAvailableRates.bind(null, filters),
        waitForResponse: true,
        dependencies: [currentPage, recall, filtersKey],
        condition: shouldFetch
    });

    // Sürekli fetch yapıldığı için her seferinde loading olmasın diye sadece filtre değişimine loading eklendi.
    const [filterLoading, setFilterLoading] = useState(false);
    const prevFiltersKey = useRef(filtersKey);

    useEffect(() => {
        if (prevFiltersKey.current !== filtersKey) {
            prevFiltersKey.current = filtersKey;
            // Fetch atılmayacaksa (örn. acente henüz Entegrasyon Tipi seçmediyse) loading gösterilmemeli.
            setFilterLoading(shouldFetch);
        }
    }, [filtersKey]);

    useEffect(() => {
        if (!loading) setFilterLoading(false);
    }, [loading]);

    useEffect(() => {
        if (isFocused) {
            let timeout = null;
            timeout = setTimeout(() => {
                setRecall(!recallRef.current);
            }, RELOAD_INTERVAL);
            return () => clearTimeout(timeout);
        }
    }, [recall, isFocused]);

    return (
        <div>
            <FiltersWrapper gap={16} align="flex-end" marginBottom="16px">
                <Filters
                    setCurrentPage={setCurrentPage}
                    setFilters={setFilters}
                    filters={filters}
                />
            </FiltersWrapper>
            <Row>
                <ResponsiveDataTable
                    loading={filterLoading}
                    data={
                        noMatchingDedicatedCompanyPools
                            ? []
                            : poolsAvailableRates?.data?.map(p => ({
                                  ...p,
                                  availableRate: isNumeric(p?.availableRate)
                                      ? parseFloat(p?.availableRate).toFixed(0)
                                      : p?.availableRate
                                  // slotRate: parseFloat(p?.slotRate).toFixed(0)
                              })) ?? []
                    }
                    dataCount={0}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                />
            </Row>
        </div>
    );
};

export default PoolIntensities;
